import { render, staticRenderFns } from "./type_4.vue?vue&type=template&id=14dd4060&scoped=true"
import script from "./type_4.vue?vue&type=script&lang=js"
export * from "./type_4.vue?vue&type=script&lang=js"
import style0 from "./type_4.vue?vue&type=style&index=0&id=14dd4060&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd4060",
  null
  
)

export default component.exports